// Vuetify

const customColors = {
  primary: '#174FD6',
  'primary-lighten1': '608AEF',
  'primary-lighten2': '82A3F3',
  'primary-lighten3': 'A4BBF6',
  'primary-lighten4': 'C5D4FA',
  'primary-lighten5': 'E3EBFD',
  'primary-darken1': '1642BE',
  'primary-darken2': '1337A7',
  'primary-darken3': '102F8E',
  'primary-darken4': '0C236E',
  'primary-accent1': '#A3BBFF',
  'primary-accent2': '#608AFE',
  'primary-accent3': '#486FFD',
  'primary-accent4': '#294FFE',

  secondary: '#0a204f',
  'secondary-low-light': '#DBE1ED',
  'secondary-medium-light': '#B6BECF',
  'secondary-high-light': '#0A204F',
  'secondary-low-dark': '#333F57',
  'secondary-medium-dark': '#7486AC',
  'secondary-high-dark': '#B8C8EC',
  
  'grey-darken5': '#111111',

  'pink-low-light': '#FCE4EC',
  'pink-medium-light': '#EC407A',
  'pink-high-light': '#AD1457',
  'pink-low-dark': '#4B0A28',
  'pink-medium-dark': '#F06292',
  'pink-high-dark': '#F48FB1',

  'blue-low-light': '#E3F2FD',
  'blue-medium-light': '#1E88E5',
  'blue-high-light': '#0D47A1',
  'blue-low-dark': '#002244',
  'blue-medium-dark': '#82B1FF',
  'blue-high-dark': '#90CAF9',

  'purple-low-light': '#F3E5F5',
  'purple-medium-light': '#AB47BC',
  'purple-high-light': '#7B1FA2',
  'purple-low-dark': '#250040',
  'purple-medium-dark': '#BA68C8',
  'purple-high-dark': '#CE93D8',

  'deep-purple-low-light': '#EDE7F6',
  'deep-purple-medium-light': '#7E57C2',
  'deep-purple-high-light': '#512DA8',
  'deep-purple-low-dark': '#1A0066',
  'deep-purple-medium-dark': '#B388FF',
  'deep-purple-high-dark': '#B39DDB',

  'teal-low-light': '#E0F2F1',
  'teal-medium-light': '#009688',
  'teal-high-light': '#00695C',
  'teal-low-dark': '#004D40',
  'teal-medium-dark': '#00BFA5',
  'teal-high-dark': '#B2DFDB',

  'cyan-low-light': '#ECFFFF',
  'cyan-medium-light': '#0090B4',
  'cyan-high-light': '#005F8B',
  'cyan-low-dark': '#004D52',
  'cyan-medium-dark': '#00B8D4',
  'cyan-high-dark': '#80DEEA',

  'brown-low-light': '#EFEBE9',
  'brown-medium-light': '#8D6E63',
  'brown-high-light': '#5D4037',
  'brown-low-dark': '#3E2723',
  'brown-medium-dark': '#B76640',
  'brown-high-dark': '#BCAAA4',

  'olive-low-light': '#F9FBD0',
  'olive-medium-light': '#7F8C12',
  'olive-high-light': '#4C5504',
  'olive-low-dark': '#3F4A03',
  'olive-medium-dark': '#8FB900',
  'olive-high-dark': '#D9DF6E',

  'amber-low-light': '#FFF8E1',
  'amber-medium-light': '#CB7F00',
  'amber-high-light': '#996600',
  'amber-low-dark': '#5E3613',
  'amber-medium-dark': '#FFAB00',
  'amber-high-dark': '#FFECB3',

  'deep-orange-low-light': '#FBE9E7',
  'deep-orange-medium-light': '#E64A19',
  'deep-orange-high-light': '#8C2B00',
  'deep-orange-low-dark': '#5E1F00',
  'deep-orange-medium-dark': '#FF6E40',
  'deep-orange-high-dark': '#FFAB91',

  'blue-grey-low-light': '#ECEFF1',
  'blue-grey-medium-light': '#607D8B',
  'blue-grey-high-light': '#455A64',
  'blue-grey-low-dark': '#3C5058',
  'blue-grey-medium-dark': '#7FB2C4',
  'blue-grey-high-dark': '#D6DEE3',

  'sky-blue-high-light': '#1E88E5',
  'sky-blue-low-light': '#E3F2FD',
  'sky-blue-high-dark': '#64B5F6',
  'sky-blue-low-dark': '#0A3578',

};

export default customColors;
